const ASSESSMENT = "Assessment" as const;
const IMPURITY = "Impurity" as const;

export { ASSESSMENT, IMPURITY };
